export const BW_MODAL_SIZES = {
  sm: 480,
  md: 680,
  lg: 900,
  xl: 1080,
  wide: '70vw',
  full: 'calc(100vw - 32px)',
};

export const BW_MODAL_SIZE_NAMES = Object.keys(BW_MODAL_SIZES);
export const BW_MODAL_TONES = ['info', 'success', 'warning', 'danger'];

export const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
  '[contenteditable="true"]',
].join(',');

export const DEFAULT_CLOSE_CONFIRMATION = {
  title: 'Bạn có thay đổi chưa được lưu',
  description: 'Nếu đóng cửa sổ, các thông tin vừa nhập sẽ không được lưu.',
  continueLabel: 'Tiếp tục chỉnh sửa',
  discardLabel: 'Đóng và bỏ thay đổi',
};
